module.exports = __webpack_public_path__ + "img/blue_bay_living_302.e8b941c1.jpeg";